export const calculatePatientCopay = (data) => {
  if (!data) {
    return {
      costEstimate: 0,
      finalCopayTotal: 0,
      finalformattedTotalcopay: 0,
    };
  }

  const GREEN = "58D68D";
  const RED = "F3082C";
  const YELLOW = "F9E79F";

  const getSafeNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const getPatientColor = () => {
    const raw = data?.deductiblemet;
    if (!raw) return "none";

    const color = String(raw).replace("#", "").toUpperCase();

    if (color === GREEN) return "green";
    if (color === RED || color === YELLOW) return "red";

    return "none";
  };

  const getCoveredPlans = () => {
    try {
      const raw = data?.appointment_specific?.insuranceCoveredPlan;
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  };

  const isVitamin = (order) =>
    order?.ordertype?.toLowerCase() === "vitamin";

  const shouldShowPrice = (order) => {
    const color = getPatientColor();

    if (color === "red") return true;
    if (color === "green") return isVitamin(order);

    return isVitamin(order);
  };

  const isOrderCovered = (orderName, coveredPlans = []) => {
    if (!orderName) return false;

    const name = orderName.trim().toUpperCase();

    if (name === "ECG/EKG") return coveredPlans.includes("EKG");
    if (name === "HOME SLEEP STUDY") return coveredPlans.includes("SLEEP STUDY");
    if (name === "ECHO") return coveredPlans.includes("ECHO");
    if (name.startsWith("US")) return coveredPlans.includes("ULTRASOUND");

    return coveredPlans.includes(name);
  };

  const paymentdetails = data?.paymentdetails || [];
  const orders = data?.orders || [];
  const coveredPlans = getCoveredPlans();

  const selfPay = getSafeNumber(data?.selfpay);
  const accountBalance = getSafeNumber(data?.acctbalance);
  const copayAmt = getSafeNumber(data?.copay);
  const paidAmount = getSafeNumber(data?.paidamount);

  const patientColor = getPatientColor();

  let costEstimate = 0;

  if (
    patientColor === "red" ||
    data?.deductiblemet?.toUpperCase() === YELLOW
  ) {
    costEstimate = Number(data?.percentage?.Amount || 0);
  } else if (patientColor === "green") {
    costEstimate = 0;
  } else {
    orders.forEach((order) => {
      if (!shouldShowPrice(order)) return;

      const matched = paymentdetails.find(
        (p) => p.content === order?.ordername
      );

      if (!matched) return;

      const isCovered = isOrderCovered(order?.ordername, coveredPlans);

      if (isCovered) return;

      const amount = isVitamin(order)
        ? Number(matched.selfpay_cost || 0)
        : Number(matched.insurance_cost || 0);

      costEstimate += amount;
    });
  }

  // ✅ Correct billing logic
  const totalDue = costEstimate + selfPay;

  const credits =
    accountBalance +
    copayAmt +
    paidAmount;

  const finalCopayTotal = Math.max(0, totalDue - credits);

  const finalformattedTotalcopay =
    finalCopayTotal % 1 === 0
      ? finalCopayTotal
      : Number(finalCopayTotal).toFixed(2);

  return {
    costEstimate,
    finalCopayTotal,
    finalformattedTotalcopay,
  };
};